import React, { Component } from 'react'
import ProjectTable from './ProjectTable'

class ReportsHome extends Component {
  render() {
    return (
      <div><ProjectTable /></div>
    )
  }
}

export default ReportsHome
